<template>
    <div :class="[custom.popup]" ref="modalDialog" @click="closeModal"></div>
    <div :class="[custom.popup_content]" ref="modalContent">
        <div class="modal-header">
            <slot name="Header"></slot>
        </div>
        <div class="modal-body overflow-y-auto" :class="[custom.popup_body]">
            <slot name="Body"></slot>
        </div>
        <div class="modal-footer">
            <slot name="Footer"></slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import custom from "../../scss/app.module.scss";
import {ref, onMounted, defineSlots} from "vue";
const modalDialog = ref<HTMLElement>();
const modalContent = ref<HTMLElement>();

defineSlots<{
    Header?({}): HTMLElement;
    Body?(): HTMLElement;
    Footer?(): HTMLElement;
}>();

const showModal = () : void =>{
    if(modalDialog.value){
        modalDialog.value.style.opacity = "1";
        modalDialog.value.style.visibility = "visible";
        modalDialog.value.style.display = "block";
    }
    if(modalContent.value){
        modalContent.value.style.opacity = "1";
        modalContent.value.style.visibility = "visible";
        modalContent.value.style.display = "block";
    }
}
const closeModal = () : void =>{
    if(modalDialog.value){
        modalDialog.value.style.opacity = "0";
        modalDialog.value.style.visibility = "hidden";
        modalDialog.value.style.display = "block";
    }
    if(modalContent.value){
        modalContent.value.style.opacity = "0";
        modalContent.value.style.visibility = "hidden";
        modalContent.value.style.display = "block";
    }
}

onMounted(()=>{
    if(modalDialog.value){
        modalDialog.value.style.opacity = "0";
        modalDialog.value.style.visibility = "hidden";
        modalDialog.value.style.display = "block";
    }
    if(modalContent.value){
        modalContent.value.style.opacity = "0";
        modalContent.value.style.visibility = "hidden";
        modalContent.value.style.display = "block";
    }
})

defineExpose({
    closeModal,
    showModal
})
</script>

<style scoped></style>
